import React, { useEffect, useState } from 'react';

// import { useTranslation } from 'react-i18next';

import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import {
  Box,
  Link,
  Container,
  Typography,
  Divider,
  Stack,
  Button,
  Chip,
  TextField,
  InputAdornment,
  IconButton
} from '@mui/material';

import {
  LoadingButton
} from '@mui/lab';

import * as yup from "yup"
import { Formik, Form } from 'formik';

import { useNavigate } from 'react-router-dom';

// hooks
import useResponsive from '../../../hooks/useResponsive'
import { useAuthAccess } from '../../../hooks/useAuthAccess';
import { useAuth, authTargetTypes } from '../../../hooks/api/useAuth';
import { useSystemPrompt } from '../../../hooks/useSystemPrompt';
import { useAppContextFeatures } from '../../../context/AppContext';
import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
import { CommonIcons, icons } from '../../common/CommonIcons';
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';

// components
import { RouteTypeChip } from '../../@layouts/RouteTypeChip';

import { getSystemLogo, logoTypes } from "../../../configs/logoConfigs"

import { getRouteTypeLabel } from '../../../configs/sidebarConfigs';

// ----------------------------------------------------------------------

import { useTranslations } from "../../../hooks/useTranslations"

import CommonTranslation from '../../common/CommonTranslation';

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  // backgroundColor: theme.palette.background.theme,
  background: "linear-gradient(to right bottom, #e8a922, #f7931e)"
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  // padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

const getAuthType = (routeType) => {
  if (routeType === routeTypes.admin) {
    return authTargetTypes.admin
  }

  if (routeType === routeTypes.retail) {
    return authTargetTypes.retail
  }

  if (routeType === routeTypes.workstation) {
    return authTargetTypes.workstation
  }

  if (routeType === routeTypes.customer) {
    return authTargetTypes.customer
  }

  if (routeType === routeTypes.member) {
    return authTargetTypes.member
  }

  return null
}


const getImage = (routeType) => {

  let url = `/assets/images/login/`

  if (routeType === routeTypes.admin) {
    return `${url}adminBg.png`
  }

  if (routeType === routeTypes.retail) {
    return `${url}retailBg.png`
  }

  if (routeType === routeTypes.workstation) {
    return `${url}workstationBg.png`
  }

  if (routeType === routeTypes.customer) {
    return `${url}customerBg.png`
  }

  if (routeType === routeTypes.member) {
    return `${url}memberBg.png`
  }

  return null
}

export default function SignUp({
  routeType
}) {

  const { t } = useTranslations({ ns: ["@access", "common"] })

  const navigate = useNavigate();

  const mdUp = useResponsive('up', 'md');

  const { promptMessage } = useSystemPrompt();
  const { isLoading, authLogin } = useAuth(getAuthType(routeType));
  const { checkIsLogin, performLogin } = useAuthAccess(getAuthType(routeType));
  const { setLocationIds } = useAppContextFeatures()
  const { getRoute } = useSystemRoutes(routeType)
  const { getHtmlHead } = useSystemHead(routeType)

  const [showPassword, setShowPassword] = useState(false);

  const validationSchema = yup.object({
    username: yup
      .string()
      .required('Required'),
    password: yup
      .string()
      .required('Required')
  })

  const initialValues = {
    username: "",
    password: ""
  }

  const onSubmit = async ({ username, password }) => {

    // try {

    //   const result = await authLogin({ username, password });

    //   const { user } = result?.data ? result.data : {}

    //   const { authData } = performLogin({
    //     displayName: `${user?.firstname} ${user?.lastname}`,
    //     profile: result?.data
    //   })

    //   // set default the global filters
    //   // const defaultLocations = authData?.profile?.user_locations;
    //   // const defaultLocationsIds = defaultLocations && defaultLocations.length? defaultLocations.map(item => item.id) : []
    //   // console.log('defaultLocations', defaultLocationsIds)

    //   navigate(getRoute('dashboard'));

    //   promptMessage(true, `Successfully Authenticated. Welcome Back, ${user?.firstname} ${user?.lastname}`)

    // } catch (error) {
    //   promptMessage(false, `Action Failed (${error?.message})`)
    // }

  }

  const RenderBanner = () => {
    return (
      <>
        <Stack
          flexDirection={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{
            position: 'fixed',
            top: { xs: 16, sm: 24, md: 40 },
            left: { xs: 16, sm: 24, md: 40 },
          }}
        >
          {
            getSystemLogo({ routeType, logoType: logoTypes.login }).component
          }
          <RouteTypeChip
            routeType={
              // routeType
              getRouteTypeLabel({ routeType, t })
            }
          />
        </Stack>


        {mdUp && (
          <StyledSection sx={{ minWidth: '40%', px: 5 }}>
            <img
              src={getImage(routeType)}
              style={{ width: '100%', paddingTop: 40, alignSelf: 'center' }}
              alt={`Login (${routeType})`}
            />
          </StyledSection>
        )}

      </>
    )
  }

  const RenderForm = () => {
    return (
      <StyledContent>
        <Typography variant="h4" gutterBottom>
          {/* {`Sign In to ${system.displayName}`} */}
          {/* {`Let's Sign You In`} */}
          {t("signUpAsMember")}
        </Typography>

        <Typography variant="body2" sx={{ mb: 5 }}>
          {/* Please provide your username and password */}
          {t("pleaseProvideYourUsernameAndPassword")}
          {/* <Link variant="subtitle2">Get started</Link> */}
        </Typography>

        <Stack direction="row" spacing={2}>
          <Button fullWidth size="large" color="inherit" variant="outlined">
            {/* <Iconify icon="eva:google-fill" color="#DF3E30" width={22} height={22} /> */}
          </Button>

          <Button fullWidth size="large" color="inherit" variant="outlined">
            {/* <Iconify icon="eva:facebook-fill" color="#1877F2" width={22} height={22} /> */}
          </Button>

          <Button fullWidth size="large" color="inherit" variant="outlined">
            {/* <Iconify icon="eva:twitter-fill" color="#1C9CEA" width={22} height={22} /> */}
          </Button>
        </Stack>

        <Divider sx={{ my: 3 }}>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            OR
          </Typography>
        </Divider>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        // enableReinitialize
        >
          {
            ({ values, errors, touched, handleChange, setFieldValue }) => (

              <Form>
                <Stack spacing={3}>

                  <TextField
                    // margin="normal"
                    // size="small"
                    autoFocus
                    fullWidth
                    name={"username"}
                    label={t("username")}
                    type="text"
                    variant="outlined"
                    value={values.username}
                    onChange={handleChange}
                    error={touched.username && Boolean(errors.username)}
                    helperText={touched.username && errors.username}
                  />

                  <TextField
                    // margin="normal"
                    // size="small"
                    fullWidth
                    name={"password"}
                    label={t("password")}
                    type={showPassword ? 'text' : 'password'}
                    variant="outlined"
                    value={values.password}
                    onChange={handleChange}
                    error={touched.password && Boolean(errors.password)}
                    helperText={touched.password && errors.password}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                            <CommonIcons name={showPassword ? icons.visible : icons.invisible} />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />

                  {/* <TextField name="email" label="Email address" /> */}

                  {/* <TextField
                          name="password"
                          label="Password"
                          type={showPassword ? 'text' : 'password'}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        /> */}
                </Stack>

                <Stack textAlign={"right"} sx={{ my: 1 }}>
                  {/* <Checkbox name="remember" label="Remember me" />
                        <Link variant="subtitle2" underline="hover">
                          Forgot password?
                        </Link> */}
                </Stack>

                <LoadingButton
                  type="submit"
                  size='large'
                  fullWidth
                  variant="contained"
                  // sx={{ 
                  //     mt: 3,
                  //     mb: 2
                  // }}
                  loading={isLoading}
                >
                  {t("signUp")}
                </LoadingButton>

              </Form>
            )
          }

        </Formik>

      </StyledContent>
    )
  }

  return (
    <>
      {
        getHtmlHead({ routeType, title: headTitles.access })
      }

      <StyledRoot>

        <RenderBanner />

        <Container maxWidth="sm">

          <Box
            style={{
              position: 'absolute',
              top: 20,
              right: 20
            }}
          >
            <CommonTranslation
              showSelection={false}
            />
          </Box>

          {
            RenderForm()
          }

        </Container>

      </StyledRoot>
    </>
  );
}
